import { useContext } from 'react';

import { ScrollContext } from '../contexts/scroll';

export function useScroll() {
  return useContext(ScrollContext);
}
